export const copyTextToClipboard = async (value: string): Promise<boolean> => {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch (e) {
    console.error(e);
  }

  try {
    const el = document.createElement("textarea");
    el.value = value;
    el.setAttribute("readonly", "true");
    el.style.position = "fixed";
    el.style.top = "-9999px";
    document.body.appendChild(el);
    el.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(el);
    return ok;
  } catch {
    return false;
  }
};

export type ShareResult = "shared" | "copied" | "failed";

export const shareUrl = async (options: {
  title: string;
  url: string;
}): Promise<ShareResult> => {
  const { title, url } = options;

  if (navigator.share) {
    try {
      await navigator.share({ title, url });
      return "shared";
    } catch (e) {
      if (
        e &&
        typeof e === "object" &&
        "name" in e &&
        e.name === "AbortError"
      ) {
        return "shared";
      }
    }
  }

  const ok = await copyTextToClipboard(url);
  return ok ? "copied" : "failed";
};
